import CustomChip from "../../../core/custom-chip";
import { Box, Tooltip, Typography } from "@mui/material";
import { convertToCamelCaseFromUnderScore } from "../../../utils";

export const HeaderConfig = [
  {
    label: "Engineer",
    id: "name",
    render: (data) => {
      return (
        <Tooltip
          title={
            <Box sx={{ width: "200px" }}>
              <div>
                <Typography sx={{ textAlign: "center" }}>
                  {data.name}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {data.email}
                </Typography>
                <Typography sx={{ textAlign: "center" }}>
                  {data?.phoneNumber}
                </Typography>
              </div>
            </Box>
          }
          arrow
        >
          <span>{data.name}</span>
        </Tooltip>
      );
    },
  },
  // {
  //   label: "Date",
  //   id: "date",
  //   render: (data) => {
  //     return <span>{new Date().toLocaleDateString()} </span>;
  //   },
  // },
  {
    label: "Reason",
    id: "reason",
  },
  {
    label: "Status",
    id: "status",
    render: (data) => {
      const value = data?.status;
      return (
        <span>
          <CustomChip
            label={convertToCamelCaseFromUnderScore(value)}
            colorKey={
              value === "IDLE"
                ? "green"
                : value === "PRE_COMMITTED"
                ? "orange"
                : value === "ON_LEAVE"
                ? "red"
                : value === "ON_JIR"
                ? "purple"
                : value === "ON_TRAINING"
                ? "pink"
                : "blue"
            }
          />
        </span>
      );
    },
  },
];
